import { Country } from '@dreryk/address-common-api';

import { commonTranslationKeys, FieldControllerProps } from '@dreryk/react-common';
import { Select, StyledMaxWidth } from '@dreryk/react-components';

import { CountriesSelectList, getCountryDisplayValue } from '~libs.desktop.shared.fields';

import { identityDocumentTranslationKeys } from '../../../../../../../translations';

type PassportCountryFieldProps = FieldControllerProps<'passportCountry', Country | null>;

export const PassportCountryField = (props: PassportCountryFieldProps): JSX.Element => {
   return (
      <StyledMaxWidth maxWidth={308}>
         <Select<Country>
            testId={props.name}
            triggerLabelExtractor={getCountryDisplayValue}
            controller={props.register(props.name, {
               required: props.required,
            })}
            defaultValue={props.defaultValue}
            label={identityDocumentTranslationKeys.passport.passportCountry.label}
            placeholder={commonTranslationKeys.choose}
            maxHeight={190}
            searchInputEnabled
         >
            <CountriesSelectList />
         </Select>
      </StyledMaxWidth>
   );
};
